import { createEntityAdapter } from "@reduxjs/toolkit"
import {
    IActionButton,
    IAttachment,
    ICollection,
    IConcept,
    IItem,
    IResourceCatalog,
    IWorkspace,
} from "./index"

export const actionButtonsAdapter = createEntityAdapter<IActionButton>()
export const actionButtonSelector = actionButtonsAdapter.getSelectors(
    (state: IResourceCatalog) => state.actionButtons,
)

export const attachmentsAdapter = createEntityAdapter<IAttachment>()
export const attachmentSelector = attachmentsAdapter.getSelectors(
    (state: IResourceCatalog) => state.attachments,
)

export const collectionsAdapter = createEntityAdapter<ICollection>()
export const collectionSelector = collectionsAdapter.getSelectors(
    (state: IResourceCatalog) => state.collections,
)

export const conceptsAdapter = createEntityAdapter<IConcept>()
export const conceptSelector = conceptsAdapter.getSelectors(
    (state: IResourceCatalog) => state.concepts,
)

export const itemsAdapter = createEntityAdapter<IItem>()
export const itemSelector = itemsAdapter.getSelectors(
    (state: IResourceCatalog) => state.items,
)

export const workspacesAdapter = createEntityAdapter<IWorkspace>()
export const workspaceSelector = workspacesAdapter.getSelectors(
    (state: IResourceCatalog) => state.workspaces,
)
